import type {
  ProductRelation, EditionFormat, Edges, MapsOn, PriceTypes, LicenseAgreementInfo,
} from './common';

interface Attachment {
  atUrl: string;
  wFormat: string;
}

export enum AttachmentFormat {
  NORMAL = 'normal',
}

export interface WileyBaseProduct {
  maName: string;
  wImages: Attachment[];
}

interface ProductRelationNode extends WileyBaseProduct { }

interface ProductRelationInput {
  mapsOn: ProductRelation;
  node: ProductRelationNode;
}

interface PurchaseOption {
  catName: string;
}

interface WileyProductVariant {
  uid: string;
  maId: string;
  wEditionFormat: EditionFormat;
  wPrintOnDemand: boolean;
  parents: ProductRelationInput[];
  maCategories: PurchaseOption[];
  parentId: string;
  categoryName: string;
  wProductLicenseAgreementInfo?: LicenseAgreementInfo;
  maName?: string;
}

export enum ProductInventoryStatus {
  PRE_ORDER = 'PRE_ORDER',
  BACK_ORDER = 'BACK_ORDER',
  ACTIVE = 'ACTIVE',
}

interface ViaxBiiSalable extends WileyProductVariant {
  status: ProductInventoryStatus | string;
}

interface ViaxBiiQuantity {
  amount: number;
}

interface DynamicEnumOutput {
  code: PriceTypes;
}

interface UnitOfMeasure {
  code: string;
}

interface Money {
  amount: number;
  units: UnitOfMeasure;
}

export interface Promotion {
  prmName: string;
  prmId: string;
  prmActive: boolean;
  wFreeStandardShipping: boolean;
}

type Price = MapsOn<DynamicEnumOutput, Money>;
export type PricPrice = Edges<Price>;

export interface ViaxOrderItem {
  uid: string;
  biiId: string;
  biiQuantity: ViaxBiiQuantity;
  biiSalable: ViaxBiiSalable;
  pricPrice: PricPrice;
  __typename: string;
}

export interface ViaxOrder {
  uid: string;
  hiConsistsOf: ViaxOrderItem[];
  pricPrice: PricPrice;
  corPromoCodes: Promotion[];
}
